import React, { useState } from "react";
import "./tilesrow.css";
import piano from "../../assets/imgs/piano.jpg";
import design from "../../assets/imgs/design.jpg";
import christmasLightShow from "../../assets/imgs/christmasLightShow.png";
import Art from "../../assets/imgs/Art.jpg";
import AI_Assistant from "../../assets/imgs/AI_Assistant.jpg";
import uncagedTile from "../../assets/imgs/uncagedTile.png";
import soulAcross from "../../assets/imgs/soulacross.png";

import img1 from "../../assets/imgs/art_photos/img1.jpg";
import img2 from "../../assets/imgs/art_photos/img2.jpg";
import img4 from "../../assets/imgs/art_photos/img3.jpg";
import img3 from "../../assets/imgs/art_photos/img4.jpg";
import img6 from "../../assets/imgs/art_photos/img5.jpg";
import img5 from "../../assets/imgs/art_photos/img6.jpg";
import img7 from "../../assets/imgs/art_photos/img7.jpg";
import img8 from "../../assets/imgs/art_photos/img8.jpg";

import design1 from "../../assets/imgs/designs/design1.jpg";
import design2 from "../../assets/imgs/designs/design2.png";
import design3 from "../../assets/imgs/designs/design3.jpg";
import design4 from "../../assets/imgs/designs/design4.jpg";
import design5 from "../../assets/imgs/designs/design5.png";
import design6 from "../../assets/imgs/designs/design6.png";
import design7 from "../../assets/imgs/designs/design7.jpg";
import design8 from "../../assets/imgs/designs/design8.jpg";

// the ROWS of the tiles.
const tiles = [
  {
    id: "c4c3d621-3349-4a4e-8546-ada11c8ee893",
    src: uncagedTile,
    altName: "Uncaged!",
    title: "Uncaged!",
    description:
      "Designed to revitalize a love for reading and create deep connections between readers. Used by 2400+ readers and unlocked over 15000 narratives. Available on Google Play, App Store, and Web.",
    callToActionText: "WEBSITE",
    linkToWebsite: "https://www.uncagedapp.com/",
    backgroundImg: uncagedTile,
    type: "Passion Projects",
  },
  {
    id: "36bc279a-e65e-4d48-bd0e-b2a89d67fedc",
    src: soulAcross,
    altName: "Soul Across",
    title: "Soul Across",
    description:
      "A non-profit formed in order to equip students in third world countries with better opportunities. Allows people to share a piece of themselves through books across the globe. ",
    callToActionText: "WEBSITE",
    linkToWebsite: "https://www.soulacross.com/",
    backgroundImg: soulAcross,
    // youtubeVideoURL: "https://www.youtube.com/watch?v=zgJfwiBkY78",
    type: "Passion Projects",
  },
  {
    id: "8f5df7e6-7660-4eb3-bd81-eab1fc8fdb39",
    src: AI_Assistant,
    altName: "Student AI Assistant",
    title: "Student AI Assistant",
    description:
      "Comprehends texts, annotations, images and tables from textbooks. Built using Llama2 LLM, Llamaparse, Pinecone, and utilizes RAG architecture.",
    // callToActionText: "Visit our website",
    // linkToWebsite: "https://www.uncagedapp.com/",
    // youtubeVideoURL: "https://www.youtube.com/watch?v=8od07dj74tE",
    backgroundImg: AI_Assistant,
    type: "Passion Projects",
  },
  {
    id: "e2a16ca6-fd41-47dd-b25b-a4cb1a601e9e",
    src: Art,
    altName: "My Artwork",
    title: "Artwork",
    description: "Pieces that I have created are shown below.",
    linkToWebsite: "https://www.uncagedapp.com/",
    backgroundImg: Art,
    type: "Designs",
    artwork: [img1, img2, img3, img4, img5, img6],
    // artwork: [design1],
  },
  {
    id: "d9b08d30-b784-4645-b172-54ad319d0fae",
    src: design,
    altName: "Designs",
    title: "Designs",
    description:
      "All of the designs I have created for various purposes, including district events, T-shirt designs, and logos for numerous companies.",
    // callToActionText: "Visit our website",
    // linkToWebsite: "https://www.uncagedapp.com/",
    // youtubeVideoURL: "https://www.youtube.com/watch?v=8od07dj74tE",
    backgroundImg: design,
    type: "Designs",
    artwork: [
      design1,
      design2,
      design3,
      design4,
      design5,
      design7,
      design6,
      design8,
    ],
  },
  {
    id: "5f14f4a0-25ba-499a-a5fb-52d165340442",
    src: piano,
    altName: "Piano",
    title: "Piano",
    description:
      "Composed and performed various pieces. Playing for over 10 years and passed all levels of Certificate of Merit.",
    // callToActionText: "Visit our website",
    // linkToWebsite: "https://www.uncagedapp.com/",
    backgroundImg: piano,
    youtubeVideoURL: "https://youtu.be/R409Xb3e13Y",
    type: "Activities",
  },
  {
    id: "bc495b78-f991-4242-8eff-52ddbc8d729b",
    src: christmasLightShow,
    altName: "Music Coordinated Light Shows",
    title: "Music Coordinated Light Shows",
    backgroundImg: christmasLightShow,
    description:
      "Created Christmas Light shows for everyone in our neighborhood to relax and enjoy!",
    // callToActionText: "Visit our website",
    // linkToWebsite: "https://www.uncagedapp.com/",
    youtubeVideoURL: "https://youtu.be/rGoGd2GrpVA",
    type: "Activities",
  },
];

export default function TilesRow({ title, onChange, topRow }) {
  return (
    <div className="row-container">
      <h2 className="row-title">{title.toUpperCase()}</h2>

      <div className="tiles-row-container">
        {tiles.map(
          (tile) =>
            tile.type == title && (
              <div
                onClick={() => {
                  onChange({
                    toggleModal: true,
                    tileDetails: {
                      title: tile.title,
                      description: tile.description,
                      callToActionText: tile.callToActionText,
                      linkToWebsite: tile.linkToWebsite,
                      youtubeVideoURL: tile.youtubeVideoURL,
                      backgroundImg: tile.backgroundImg,
                      artwork: tile.artwork,
                    },
                  });
                }}
              >
                <img
                  key={tile.id}
                  className={`image-tile ${topRow && "image-tile-top-row"}`}
                  src={tile.src}
                  alt={tile.altName}
                />
              </div>
            )
        )}
      </div>
    </div>
  );
}
